module.exports = __webpack_public_path__ + "img/20.6f5d2ab.png";